import { useSiteContent } from "@/hooks/useSiteContent";
import { MessageCircle } from "lucide-react";

export function WhatsAppFab() {
  const { content } = useSiteContent();
  return (
    <a
      href={`https://wa.me/91${content.whatsapp_number || content.shop_phone}?text=Hello%20${encodeURIComponent(content.shop_name)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-elegant hover:scale-110 transition-smooth animate-float"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
